import React, { Dispatch } from 'react';
import { ReportFlowStep } from '../constants';
import { FiltersWrapper } from './filtersWrapper';
import { IProfitAndLossFilters } from '../constants/types';

interface IProps {
  activeStep: ReportFlowStep | undefined;
  filterObject: IProfitAndLossFilters;
  setFilterObject: Dispatch<React.SetStateAction<IProfitAndLossFilters>>;
}

export const Header = ({ activeStep, filterObject, setFilterObject }: IProps) => (
  <div className='pt-[16px] pb-[4px] pl-[24px] pr-[16px] border-b-[1px] border-bw03 flex items-center justify-between '>
    {activeStep === ReportFlowStep.REPORT && (
      <FiltersWrapper filterObject={filterObject} setFilterObject={setFilterObject} />
    )}
  </div>
);
